<template>
  <div class="hello">
    <div v-if="loader">
      <Loader/>
    </div>
    <div v-else class="survey-banner">
      <div class="container-fluid">
        <div class="row">

          <div class="col-lg-12 iq-login-regi">
            <div class="align-items-center d-flex justify-content-center">
              <h3>{{headerText}}</h3>
            </div>
            <hr>
            <div class="align-items-center d-flex justify-content-center">
              <a>{{descriptionText}}</a>
            </div>
            <br>
            <div>
              {{DateOfDescription}} <input v-model="tookAt">
            </div>
            <div class="align-items-center d-flex justify-content-center">
              <button type="submit " class="button" v-on:click="startClicked">{{startButtonText}}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- <div class="main-content">
      <section class="how-it-works conection-shap">
        <div class="container">
          
        </div>
      </section>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import Api from "@/services/api"

export default {
  components: {
    Loader: () => import('@/components/Loader.vue')
  },
  filters: {
    moment (date) {
      return moment(date).format('YYYY-MM-DD');
    }
  },
  data () {
    return {
      loader: true,
      date: moment(),
      tookAt: moment(this.date).format('YYYY-MM-DD'), 
      survey: {},
      details: '',
      validate: false,
      isStartClicked: false,

      DateOfDescription: '記載日（西暦）:',
      headerText: '',
      descriptionText: '',

      headerText1: '肺非結核性抗酸菌症ならびに気管支拡張症の診療のための問診票',
      headerText2: '生活の質に関する質問–気管支炎',
      headerText3: 'セントジョージの呼吸器に関するアンケート',
      headerText4: 'あなたの健康について',
      headerText5: '国際標準化身体活動質問票',
      headerText6: 'HADS',
      headerText7: 'Fスケール',
      headerText8: 'COPDアセスメントテスト(CAT)',
      
      descriptionText1: '皆さんの健康状態について記載をお願い致します。質問の内容には、普段主治医が質問してい る内容も重複していますが、現在の正確な病状を記録するため、改めてお尋ねします。この情 報は主治医が確認して普段の診療にいかされるとともに、個人情報を完全に消去した上で他の 患者さんの情報とあわせて分析されます。下記項目にお答えください。（該当する項目にレを 記入してください）',
      descriptionText2: 'あなたの病気やその治療が日常生活に与える影響についてこの質問票でお答えいただく情報は、医師があなたの健康状態を観察したり、治療を調整したりする上で役立ちます。この理由から、特に気管支拡張症の方々を対象とした生活の質に関する質問票を作成しました。ご協力に感謝いたします。',
      descriptionText3: 'このアンケートは､呼吸器疾患のためにどのように皆さんが困っておられるか、またそれが皆さんの生活にどのような影響を及ぼしているかを、私どもがもっとよく知るために作成されたものです。医師や看護婦が皆さんの健康問題をどのように考えているかよりは、病気のどういった面があなたに大きな障害を引き起こしているかを明らかにするためにこのアンケートを使用しています。説明を十分にお読みになった上で、おわかりにならない点はなんでもお尋ね下さい。回答を決めるまでにあまり時間をかけすぎないようにして下さい｡',
      descriptionText4: 'このアンケートはあなたがご自分の健康をどのように考えているかをおうかがいするものです。あなたが毎日をどのように感じ、日常の活動をどのくらい自由にできるかを知るうえで参考になります。お手数をおかけしますが、何卒ご協力のほど宜しくお願い申し上げます。',
      descriptionText5: 'これからの質問は、みなさまが日常生活の中でどのように身体活動を行っているか（どのように体を動かしているか）を調べるものです。平均的な１週間を考えた場合、あなたが1日にどのくらいの時間、体を動かしているのかをお尋ねしていきます。身体活動（体を動かすこと）とは、仕事での活動、通勤や買い物などいろいろな場所への移動、家事や庭仕事、余暇時間の運動やレジャーなどのすべての身体的な活動を含んでいることに留意して下さい。回答にあたっては以下の点にご注意下さい。強い身体活動とは、身体的にきついと感じるような、かなり呼吸が乱れるような活動を意味します。中等度の身体活動とは、身体的にやや負荷がかかり、少し息がはずむような活動を意味します。',
      descriptionText6: '',
      descriptionText7: '問診票をご本人様にお渡し下さい。問診票の結果を参考にして、内視鏡検査等を実施します。治療経過中の効果を確認する時は、 ～ を実施します。',
      descriptionText8: 'あなたのCOPD(慢性閉塞性肺疾患)の状態は、いかがですか?COPDアセスメントテスト(CAT)をやってみましょう!この質問表は、COPD(慢性閉塞性肺疾患)の状態が健康と日常生活にどのような影馨を与えているか、あなたご自身と主治医の先生が知り、共有するものです。このテストによって、今のCOPDの状態を的確に先生に伝えられ、またテストの点数によってあなたの状態により合った治療を行うことができるようになります。',

      requiredTextPerson: 'あなたのIDが必要です',
      requiredTextDoctor: '担当先生の名前',
      requiredTextFiller: 'この項目はは必須です。',
      
      startButtonText: '開始',
      goToHomeText: 'アンケート一覧へ',
      savingMsg: '結果を保存しています。。。',
      successMsg: '結果は正常に保存されました！',
      failedMsg: 'エラーが発生したため、結果を保存できませんでした。',

      survey_id: this.$route.params.survey_id,

      surveyText1: 'QUESTIONNAIRE FOR NONTUBERCULOUS MYCOBACTERIAL PULMONARY DISEASE AND BRONCHIECTASIS',
      surveyText2: 'QUALITY OF LIFE QUESTIONNAIRE – BRONCHIECTASIS',
      surveyText3: 'THE ST. GEORGE’S RESPIRATORY QUESTIONNAIRE',
      surveyText4: 'ABOUT YOUR HEALTH',
      surveyText5: 'INTERNATIONAL STANDARDIZED PHYSICAL ACTIVITY QUESTIONNAIRE',
      surveyText6: 'HADS',
      surveyText7: 'FSCALE',
      surveyText8: 'COPD Assessment Test (CAT)'
    }
  },
  computed: {
    SiteLanguage () {
      return this.$store.state.siteLanguage
    }
  },
  watch: {
    SiteLanguage (newSiteLanguage, oldSiteLanguage) {
      this.setLanguage(newSiteLanguage);
    }
  },
  methods: {
    startClicked(event){
      event.preventDefault();
      this.isStartClicked = true;
      this.$router.push('/surveys/' + this.survey_id + '?took_at=' + this.tookAt);
    },
    setLanguage(siteLanguage){
    // this.survey.locale = siteLanguage
      if(siteLanguage==="ja"){
        this.DateOfDescription = '記載日（西暦）:'
        this.startButtonText = "開始";
        
        this.requiredTextPerson = 'あなたのIDが必要です';
        this.requiredTextDoctor = '担当の先生の名前が必要です';
        this.requiredTextFiller = 'この項目は必須です。';
        this.goToHomeText = 'アンケート一覧へ';
        this.savingMsg = '結果を保存しています。。。';
        this.successMsg = '結果は正常に保存されました！';
        this.failedMsg = 'エラーが発生したため、結果を保存できませんでした。';

        this.headerText1 = '肺非結核性抗酸菌症ならびに気管支拡張症の診療のための問診票'
        this.headerText2 = '生活の質に関する質問–気管支炎'
        this.headerText3 = 'セントジョージの呼吸器に関するアンケート'
        this.headerText4 = 'あなたの健康について'
        this.headerText5 = '国際標準化身体活動質問票'
        this.headerText6 = 'HADS'
        this.headerText7 = 'Fスケール'
        this.headerText8 = 'COPDアセスメントテスト(CAT)'
        
        this.descriptionText1 = '皆さんの健康状態について記載をお願い致します。質問の内容には、普段主治医が質問してい る内容も重複していますが、現在の正確な病状を記録するため、改めてお尋ねします。この情 報は主治医が確認して普段の診療にいかされるとともに、個人情報を完全に消去した上で他の 患者さんの情報とあわせて分析されます。下記項目にお答えください。（該当する項目にレを 記入してください）'
        this.descriptionText2 = 'あなたの病気やその治療が日常生活に与える影響についてこの質問票でお答えいただく情報は、医師があなたの健康状態を観察したり、治療を調整したりする上で役立ちます。この理由から、特に気管支拡張症の方々を対象とした生活の質に関する質問票を作成しました。ご協力に感謝いたします。'
        this.descriptionText3 = 'このアンケートは､呼吸器疾患のためにどのように皆さんが困っておられるか、またそれが皆さんの生活にどのような影響を及ぼしているかを、私どもがもっとよく知るために作成されたものです。医師や看護婦が皆さんの健康問題をどのように考えているかよりは、病気のどういった面があなたに大きな障害を引き起こしているかを明らかにするためにこのアンケートを使用しています。説明を十分にお読みになった上で、おわかりにならない点はなんでもお尋ね下さい。回答を決めるまでにあまり時間をかけすぎないようにして下さい｡'
        this.descriptionText4 = 'このアンケートはあなたがご自分の健康をどのように考えているかをおうかがいするものです。あなたが毎日をどのように感じ、日常の活動をどのくらい自由にできるかを知るうえで参考になります。お手数をおかけしますが、何卒ご協力のほど宜しくお願い申し上げます。'
        this.descriptionText5 = '以下の質問は、みなさまが日常生活の中でどのように身体活動を行っているか（どのよ うに体を動かしているか）を調べるものです。平均的な１週間を考えた場合、あなたが 1 日にどのくらいの時間、体を動かしているのかをお尋ねしていきます。身体活動（体を動 かすこと）とは、仕事での活動、通勤や買い物などいろいろな場所への移動、家事や庭仕 事、余暇時間の運動やレジャーなどのすべての身体的な活動を含んでいることに留意して 下さい。回答にあたっては以下の点にご注意下さい。強い身体活動とは、身体的にきついと感じるような、かなり呼吸が乱れるような活動を意味します。中等度の身体活動とは、身体的にやや負荷がかかり、少し息がはずむような活動を意味します。'
        this.descriptionText6 = ''
        this.descriptionText7 = '問診票をご本人様にお渡し下さい。問診票の結果を参考にして、内視鏡検査等を実施します。治療経過中の効果を確認する時は、 ～ を実施します。'
        this.descriptionText8 = 'ぁなたのCOPD(慢性閉曇性肺疾患)の状態は、いかがですか? COPDアセスメントテスト(CAT)をゃってみましょう! この質問表は、COPD(攫性閑塞性肺疾憲〉の状態が健康と日鸞生活にどのような影馨を与えているか、 ぁなたご目身と主治医の先生が知り、 共有するものです〟 このテストにょって、今のCOPDの状態を的確に先生に伝えられ、 またテストの点数によって、 ぁなたの状態により合った治瘡を行ぅことができるよぅになります'

        this.setDescription ()
      }
      else{
        this.DateOfDescription = 'Date of description (AD):'
        this.startButtonText = 'Start';
        this.requiredTextPerson = 'Your ID is required';
        this.requiredTextDoctor = 'Attending doctor name is required';
        this.requiredTextFiller = 'The activity field is required.';
        this.goToHomeText = 'Go to Home Page';
        this.savingMsg = 'The results are saving on the server...';
        this.successMsg = 'The results were saved successfully!';
        this.failedMsg = 'An error occurred and we could not save the results.';

        this.headerText1 = 'QUESTIONNAIRE FOR NONTUBERCULOUS MYCOBACTERIAL PULMONARY DISEASE AND BRONCHIECTASIS'
        this.headerText2 = 'QUALITY OF LIFE QUESTIONNAIRE – BRONCHIECTASIS'
        this.headerText3 = 'THE ST. GEORGE’S RESPIRATORY QUESTIONNAIRE'
        this.headerText4 = 'ABOUT YOUR HEALTH'
        this.headerText5 = 'INTERNATIONAL STANDARDIZED PHYSICAL ACTIVITY QUESTIONNAIRE'
        this.headerText6 = 'HADS'
        this.headerText7 = 'FSCALE'
        this.headerText8 = 'COPD Assessment Test (CAT)'

        this.descriptionText1 = "Please describe your health condition. The content of the question is usually asked by the attending physician Although the contents are duplicated, I will ask you again to record the current accurate medical condition. This feeling The information will be confirmed by the attending physician and used for daily medical care, and after the personal information has been completely erased, other information will be used. It will be analyzed together with the patient's information. Please answer the following items. (Check the applicable items Please fill in)"
        this.descriptionText2 = 'Understanding the impact of your illness and treatments on your everyday life can help your doctor monitor your health and adjust your treatments. For this reason, we have developed a quality of life questionnaire specifically for people who have bronchiectasis. Thank you for your willingness to complete this questionnaire.'
        this.descriptionText3 = 'This survey was created to help us better understand how you are in trouble because of respiratory illness and how it is affects your life. We use this survey to clarify what aspects of your illness are causing you major disability, rather than how doctors and nurses think of your health problems. Please read the explanation carefully and ask any questions you may not understand. Do not spend too much time deciding on an answer.'
        this.descriptionText4 = 'This survey asks you how you think about your health. It will help you to know how you feel every day and how free you are in your daily activities. We apologize for the inconvenience, and thank you for your cooperation.'
        this.descriptionText5 = 'The following questions are to find out how you are doing physical activity (how you are moving) in your daily life. Given the average week, we will ask you how much time you are exercising each day. Physical activity (exercise) includes all physical activities such as work activities, moving to various places such as commuting and shopping, housework and garden work, leisure exercise and leisure. Please keep in mind the following points when answering. Strong physical activity means activities that make you feel physically tight and that your breathing is considerably disturbed. Moderate physical activity means activity that is a little physically stressful and a little breath taking.'
        this.descriptionText6 = ''
        this.descriptionText7 = 'Please hand the questionnaire to yourself. We will carry out endoscopy, etc. by referring to the results of the questionnaire. To check the effect during the course of treatment, carry out.'
        this.descriptionText8 = 'How is your COPD (chronic obstructive pulmonary disease) condition? Let us do the COPD Assessment Test (CAT)! This questionnaire shows how the condition of COPD (Chronic Obstructive Pulmonary Disorder) affects health and daily life. It is something that you and your doctor know and share if you are giving it. By this test, The current state of COPD can be accurately communicated to the teacher, and depending on the test score, you can change to your state. You will be able to perform a better treatment.'

        this.setDescription ()
      }
    },
    setDescription () {
      if (this.survey.default == this.surveyText1) {
        this.headerText = this.headerText1
        this.descriptionText = this.descriptionText1
      }
      if (this.survey.default == this.surveyText2) {
        this.headerText = this.headerText2
        this.descriptionText = this.descriptionText2
      }
      if (this.survey.default == this.surveyText3) {
        this.headerText = this.headerText3
        this.descriptionText = this.descriptionText3
      }
      if (this.survey.default == this.surveyText4) {
        this.headerText = this.headerText4
        this.descriptionText = this.descriptionText4
      }
      if (this.survey.default == this.surveyText5) {
        this.headerText = this.headerText5
        this.descriptionText = this.descriptionText5
      }
      // if (this.survey.default == this.surveyText6) {
      //     this.$router.push('/surveys/' + this.survey_id)
      // //   this.headerText = this.headerText6
      // //   this.descriptionText = this.descriptionText6
      // }
      // if (this.survey.default == this.surveyText7) {
      //   this.headerText = this.headerText7
      //   this.descriptionText = this.descriptionText7
      // }
      if (this.survey.default == this.surveyText8) {
        this.headerText = this.headerText8
        this.descriptionText = this.descriptionText8
      }
    }
  },
  created () {
    this.setLanguage(this.$store.state.siteLanguage)
    
    Api.get('/survey/'+this.survey_id)
      .then(response => {
        if(response.data.title) {
          this.loader = false;
          this.survey = response.data.title          
          this.setDescription ()
          console.log('survey title', JSON.stringify(this.survey))
        }
      })
      .catch(error => {
        // console.log(error)
      })
      .finally(()=>{

    })
  }
}
</script>

<style scoped>
.survey-banner {
  padding: 150px 90px 65px 90px;
}
</style>

<style lang="scss">
.iq-login-regi {
  padding: 0px;
  .iq-login {
    border: none;
  }
}
.progress-bar {
  background-color: #28a745;
}
.progress {
  width: 100% !important;
  height: 1.5rem !important;
  background-color: #E0E0E0;
}
.panel-footer {
  display: flex;
  justify-content: space-between;
  .sv_prev_btn {
    background-color: #f0831e;
    color: #fff;
  }
  .sv_next_btn {
    background-color: #28a745;
    color: #fff;
  }
  .sv_complete_btn {
    background-color: #28a745;
    color: #fff;
  }
}
</style>